<template>
  <div class='box' v-if="num !== 1">
    <el-row justify="space-around" v-if="value.menuContant[0].cont[0].tatil!==''">
        <el-col :span='span' v-for="(item,index) in value.menuContant" :key='index'>
            <div class="list_boxs1" style="display:flex;flex-flow: column;margin:0 auto">
                <h3>{{item.tatil}}</h3>
                <el-divider v-if="item.tatil !== ''"></el-divider>
                <el-link :underline="false" v-for='(itemc,indexc) in item.cont' @click="gotopath(value.id,itemc.id,itemc)" :key='indexc'>{{itemc.name}}</el-link>
            </div>
        </el-col>
    </el-row>
    <el-row justify="space-around" v-else>
        <el-col :span='span' v-for="(item,index) in value.menuContants" :key='index'>
            <div class="list_boxs1" style="display:flex;flex-flow: column;margin:0 auto">
                <h3>{{item.tatil}}</h3>
                <el-divider v-if="item.tatil !== ''"></el-divider>
                <el-link :underline="false" v-for='(itemc,indexc) in item.cont' @click="gotopath(value.id,itemc.id,itemc)" :key='indexc'>{{itemc.name}}</el-link>
            </div>
        </el-col>
    </el-row>
  </div>

    <div class='boxs' v-else>
      <el-row justify="space-around">
          <el-col :span='16'>

                <el-row>
                    <el-col>
                        <div class="list_boxs1" style="display:flex;flex-flow: column;margin:0 auto">
                            <h3>{{value.menuContant[0].tatil}}</h3>
                            <el-divider v-if="value.menuContant[0].tatil !== ''"></el-divider>
                            <el-link :underline="false" v-for='(itemc,indexc) in value.menuContant[0].cont' @click="gotopath(value.id,itemc.id,itemc)" :key='indexc'>{{itemc.name}}</el-link>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="list_boxs1" style="display:flex;flex-flow: column;margin:0 auto">
                            <h3>{{value.menuContant[1].tatil}}</h3>
                            <el-divider v-if="value.menuContant[1].tatil !== ''"></el-divider>
                            <el-link :underline="false" v-for='(itemc,indexc) in value.menuContant[1].cont' @click="gotopath(value.id,itemc.id,itemc)" :key='indexc'>{{itemc.name}}</el-link>
                        </div>
                    </el-col>
                </el-row>
                

                <el-row>
                    <el-col  :class="lang == 'en-US'? 'box_none':''">
                        <div class="list_boxs1" style="display:flex;flex-flow: column;margin:0 auto">
                            <h3>{{value.menuContant[2].tatil}}</h3>
                            <el-divider v-if="value.menuContant[2].tatil !== ''"></el-divider>
                            <el-link :underline="false" v-for='(itemc,indexc) in value.menuContant[2].cont' @click="gotopath(value.id,itemc.id,itemc)" :key='indexc'>{{itemc.name}}</el-link>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="list_boxs1" style="display:flex;flex-flow: column;margin:0 auto">
                            <h3>{{value.menuContant[3].tatil}}</h3>
                            <el-divider v-if="value.menuContant[3].tatil !== ''"></el-divider>
                            <el-link :underline="false" v-for='(itemc,indexc) in value.menuContant[3].cont' @click="gotopath(value.id,itemc.id,itemc)" :key='indexc'>{{itemc.name}}</el-link>
                        </div>
                    </el-col>
                </el-row>
                


                
          </el-col>
          <el-col :span='8'>
                <div class="list_boxs1" style="display:flex;flex-flow: column;margin:0 auto">
                    <h3>{{value.menuContant[4].tatil}}</h3>
                    <el-divider v-if="value.menuContant[4].tatil !== ''"></el-divider>
                    <el-link :underline="false" v-for='(itemc,indexc) in value.menuContant[4].cont' @click="gotopath(value.id,itemc.id,itemc)" :key='indexc'>{{itemc.name}}</el-link>
                </div>
          </el-col>
      </el-row>
  </div>

</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import report from '@/api/report.js'
import { getDefaultStartTime, formatDates } from "@/util/date";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props:{
        value:{
            type:Object
        },
        num:{
            type:Number
        },
        list:{
            type:Array 
        }

    },
  data () {
  // 这里存放数据
    return {
        sonObj:{},
        arrlist:[],
        lang:this.$i18n.locale,
        span:24,
        gutter:0,
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
      '$i18n.locale'(val) {
        console.log(123,val)
        this.lang = val
    },

  },
  // 方法集合
  methods: {
    //   getActiveList(){
    //         if(this.list && this.list.length > 0){
    //             this.arrlist = this.list
    //             this.$t('header.menu')[4].menuContants[0].cont = []
    //             this.$t('header.menu')[4].menuContants[1].cont = []
    //             for(let i = 0 ; i < this.arrlist.length ; i++){
    //                 if(this.arrlist[i].categoryId == 1){
    //                     if(this.lang == 'en-US'){
    //                         this.$t('header.menu')[4].menuContants[1].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleEn+' - '+this.arrlist[i].releaseDateEn})
    //                     }else{
    //                         this.$t('header.menu')[4].menuContants[1].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleZh+' - '+this.formatDates(this.arrlist[i].releaseDateZh)})
    //                     }
    //                 }else{
                        
    //                     if(this.lang == 'en-US'){
    //                         this.$t('header.menu')[4].menuContants[0].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleEn})
    //                     }else{
    //                         this.$t('header.menu')[4].menuContants[0].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleZh})
    //                     }
    //                 }
    //             }
    //             if(this.$t('header.menu')[4].menuContants[1].cont.length > 4){
    //                 this.$t('header.menu')[4].menuContants[1].cont = this.$t('header.menu')[4].menuContants[1].cont.slice(0, 4)
    //                 if(this.lang == 'en-US'){
    //                     this.$t('header.menu')[4].menuContants[1].cont.push({id:1,name:'...More'})
    //                 }else{
    //                     this.$t('header.menu')[4].menuContants[1].cont.push({id:1,name:'...更多'})
    //                 }
    //             }
    //             if(this.$t('header.menu')[4].menuContants[0].cont.length > 4){
    //                 this.$t('header.menu')[4].menuContants[0].cont = this.$t('header.menu')[4].menuContants[0].cont.slice(0, 4)
    //                 if(this.lang == 'en-US'){
    //                     this.$t('header.menu')[4].menuContants[0].cont.push({id:1,name:'...More',categoryId:1})
    //                 }else{
    //                     this.$t('header.menu')[4].menuContants[0].cont.push({id:1,name:'...更多',categoryId:1})
    //                 }
    //             }
    //             console.log('header====>',this.arrlist,this.$t('header.menu'))
    //         }
    //   },
      gotopath(row,id,itemc){
          this.$bus.$emit('changeid', id)
          if(row == 1){
              this.$router.push({path:'/btc',query: {id:id}})
          }else if(row == 2){
              this.$router.push({path:'/services',query: {id:id}})
          }else if(row == 3){
              if(id == '7'){
                  this.$router.push({path:'/nftmarket',query: {id:id}})
              }else{
                  this.$router.push({path:'/markets',query: {id:id}})
              }
          }else if(row == 4){
              this.$router.push({path:'/regulation',query: {id:id}})
          }else if(row == 5){
              this.$router.push({path:'/research',query: {id:id}})
          }else if(row == 6){
              this.$router.push({path:'/about',query: {id:id}})
          }
          this.childvalue = false
          this.$emit('childvalue',this.childvalue)
      },
      formatDates: function (dataVal) {
        if (null == dataVal) {
            return "";
        }
        return formatDates(dataVal);
      },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
      
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    //   this.getActiveList()
      if(this.value.menuContant.length){
          let sum = this.value.menuContant.length
          if(sum == 1){
                this.span = 8
            }
      }else{
          this.span = 8
      }
      
      
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.box{
    margin:0;
    padding:0;
    .el-col{
        width: auto;
        margin-left:100px;
    }

}
.boxs{
    .el-col{
        // width: auto;
        margin-left:50px;
    }
}

h3{
    font-size:16px;
    font-weight:800;
    color: #218CBA;
    padding:20px 0 0 0;
    margin-bottom:15px;
}

::v-deep .el-link{
    font-size: 13px;
    padding: 0;
    margin-bottom:5px;
    font-weight: normal;
    color: #80838D !important;
}

::v-deep .el-col{
    padding-right:30px;
}

.el-divider--horizontal{
    margin:0;
    margin-bottom:20px;
    width: 200px;
    background: #218CBA;
}

.list_boxs1{
    display: flex;
    flex-flow: column;
}
@media screen and (max-width: 1000px){
    .box {
        h3{
            font-size:14px;
        }
        .el-link{
            font-size:12px;
        }
        .el-col{
            width: auto;
            margin-left:50px;
        }
        .el-divider--horizontal{
            width: 150px;
        }
    }
    .boxs {
        h3{
            font-size:14px;
        }
        .el-link{
            font-size:12px;
        }

        .el-col{
            width: auto;
            margin-left:20px;
        }
        .box_none{
            margin-left:-10px;
        }

        .el-divider--horizontal{
            width: 180px;
        }
    }
}

@media screen and (min-width: 1000px) and (max-width: 1460px){
    
    .box {
        h3{
            font-size:14px;
        }
        .el-link{
            font-size:12px;
        }
        .el-col{
            width: auto;
            margin-left:50px;
        }
        .el-divider--horizontal{
            width: 220px;
        }
    }
    .boxs {
        h3{
            font-size:14px;
        }
        .el-link{
            font-size:12px;
        }

        .el-col{
            width: auto;
            margin-left:20px;
        }
        .el-divider--horizontal{
            width: 220px;
        }
    }
}
@media screen and (min-width: 1460px) and (max-width: 1760px){
    
    .box {
        h3{
            font-size:16px;
        }
        .el-link{
            font-size:14px;
        }
    }
    .boxs {
        h3{
            font-size:16px;
        }
        .el-link{
            font-size:14px;
        }
    }

}
</style>
